import { ExtractRouteParams, generatePath } from 'react-router'
import qs from 'qs'

export const ADMIN_ROUTE = '/administration'
export enum PathRoutes {
  MAIN = '/',
  COURSES = '/administration/courses',
  TEMPLATES = '/administration/courses/templates',
  CERTIFICATE_TEMPLATES_STANDARD = '/administration/courses/templates/standard',
  CERTIFICATE_TEMPLATES_LEGAL = '/administration/courses/templates/legal',
  EXTERNAL_COURSES = '/administration/courses/external',
  SURVEY_BANK = '/administration/courses/survey-bank',
  SURVEY_BANK_NEW = '/administration/courses/survey-bank/new',
  SURVEY_BANK_EDIT = '/administration/courses/survey-bank/:id/edit',
  COURSES_COURSES_TAB = '/administration/courses/courses',
  COURSES_CERTIFICATES_TAB = '/administration/courses/certificates',
  COURSES_EXTERNAL_COURSES_TAB = '/administration/courses/externalCourses',
  COURSE_PREVIEW = '/administration/courses/:courseId/preview',
  EXTERNAL_COURSE = '/administration/courses/external/:id',
  MONITORING = '/administration/monitoring',
  MONITORING_AREAS = '/administration/monitoring/areas',
  MONITORING_COURSES = '/administration/monitoring/courses',
  MONITORING_EXTERNAL_COURSES = '/administration/monitoring/external_courses',
  MONITORING_PARTICIPANTS = '/administration/monitoring/participants',
  MONITORING_LEARNING_PATHS = '/administration/monitoring/learning-paths',
  MONITORING_COURSE = '/administration/monitoring/courses/:id',
  MONITORING_EXTERNAL_COURSE = '/administration/monitoring/courses/external/:id',
  LEARNING_PATHS_CREATE = '/administration/learning-paths/create',
  LEARNING_PATHS_UPDATE = '/administration/learning-paths/update/:id',
  SCORM = '/scorm/:id',
  PARTICIPANT_COURSE_RESULTS = '/configuration/user-profile/:userId/courses/:courseId/results',
  CERTIFICATE_GENERATE = '/certificate/:certificateId/:courseId/generate',
  DOWNLOAD_CERTIFICATE = '/download-certificate/user/:userId/certificates/:certificateIds/courses/:courseIds',
  DC3_CERTIFICATE_DOWNLOAD = '/dc3-certificate/download/course/:courseId/user/:userId',
  COURSE_CERTIFICATES_GENERATE = '/course/:courseId/certificates/generate',
  IMPORT_CENTER = '/import-center',
  LEARNING_PATHS = '/administration/learning-paths',
  REPORTS = '/reports',
  ROLES_AND_PERMISSIONS = '/configuration/roles-and-permissions',
  ROLES_AND_PERMISSIONS_USERS = '/configuration/roles-and-permissions/users/:roleId?',
  ROLES_AND_PERMISSIONS_ROLES_CREATE = '/configuration/roles-and-permissions/roles/create',
  ROLES_AND_PERMISSIONS_ROLES_EDIT = '/configuration/roles-and-permissions/roles/edit/:id',
  AUDIT = '/configuration/audit',
  AUDIT_BLOCK = '/configuration/audit/:block',
}

export * from './profile'

export type RecordRoute<K extends keyof any> = Record<K, string>

export type ExternalCourseProps = RecordRoute<'id'>
export const createRouteExternalCourse = (params: ExternalCourseProps) =>
  generatePath(PathRoutes.EXTERNAL_COURSE, params)

export type MonitoringCourseProps = RecordRoute<'id'>
export const createRouteMonitoringCourse = (params: MonitoringCourseProps) =>
  generatePath(PathRoutes.MONITORING_COURSE, params)

export type MonitoringExternalCourseProps = RecordRoute<'id'>
export const createRouteMonitoringExternalCourse = (
  params: MonitoringExternalCourseProps
) => generatePath(PathRoutes.MONITORING_EXTERNAL_COURSE, params)

export type CoursePreviewProps = RecordRoute<'courseId'>
export const createRouteCoursePreview = (params: CoursePreviewProps) =>
  generatePath(PathRoutes.COURSE_PREVIEW, params)

export type ExternalCoursePreviewProps = RecordRoute<'id'>
export const createRouteExternalCoursePreview = (
  params: ExternalCoursePreviewProps
) => generatePath(PathRoutes.EXTERNAL_COURSE, params)

export type RouteScormProps = RecordRoute<'id'>
export const createRouteScorm = (params: RouteScormProps) =>
  generatePath(PathRoutes.SCORM, params)

export type ParticipantCourseResultsProps = RecordRoute<'userId' | 'courseId'>
export const createRouteParticipantCourseResults = (
  params: ParticipantCourseResultsProps
) => generatePath(PathRoutes.PARTICIPANT_COURSE_RESULTS, params)

export type CertificateGenerateProps = RecordRoute<'certificateId' | 'courseId'>
export const createRouteCertificateGenerate = (
  params: ExtractRouteParams<PathRoutes.CERTIFICATE_GENERATE>
) => generatePath(PathRoutes.CERTIFICATE_GENERATE, params)

export type CourseCertificatesGenerateQueryParams = {
  allSelected?: boolean
  users?: string[]
  q?: []
  search: string
}

export const createRouteCourseCertificatesGenerate = (
  params: ExtractRouteParams<PathRoutes.COURSE_CERTIFICATES_GENERATE>,
  queryParams?: CourseCertificatesGenerateQueryParams
) =>
  generatePath(PathRoutes.COURSE_CERTIFICATES_GENERATE, params) +
  qs.stringify(queryParams, { addQueryPrefix: true })

export type CertificateTemplatesTabSlug = 'standard' | 'legal'

export const createRouteCertificateTemplatesTab = (
  tab: CertificateTemplatesTabSlug
) => `${PathRoutes.TEMPLATES}/${tab}`

export type AuditBlockProps = RecordRoute<'block'>
export const createRouteAuditBlock = (params: AuditBlockProps) =>
  generatePath(PathRoutes.AUDIT_BLOCK, params)
